import View from './view/CanViewLabInitialState'

const { Record } = require('immutable');

export default Record({
    view: View()
});